<!--  <app-gen-input title_ph_lang="patient" [actualObj]="row" (click)="openPatient(row)"  fieldName="personName" />-->
<div
	titleLang="arrived"
	class="d-flex align-items-center"
>
	<app-yes-no
		(onClick)="updField('arrived')"
		[isCheck]="row.arrived == 'yes'"
	></app-yes-no>
	<div
		titleLang="patient"
		[class.patient]="!!row.patient_id"
	>
		<app-patient-modal [id]="row.patient_id">
			{{ row.personName }}
		</app-patient-modal>
	</div>
</div>

<app-wysiwyg
	#descriptionWysiwyg
	[actualObj]="row"
	fieldName="remarks"
	tabindex="-1"
	title_ph_lang="medical_record"
	(changeEvent)="updField('remarks')"
	showTestsBtn
	(openTests)="modalProps = { name: 'tests-menu' }"
	showAutotextsBtn
	(openAutotexts)="modalProps = { name: 'autotext-menu' }"
	[initHeight]="eventsService.isMobile ? eventsService.MobileHeight - 630 : 0"
	class="sub-item"
/>
<!--  showAutotextsBtn (openAutotexts)="openAutoTextMenu()"-->
<!--        <app-gen-input type="textarea"  [actualObj]="row" fieldName="remarks" (changeEvent)="updField('remarks')" />-->

<div class="d-flex align-items-end gap-4 mis-auto sub-item">
	@if (row.patient_id && hasPayors) {
		<app-gen-autocomplete
			title_ph_lang="payor"
			[actualObj]="row"
			fieldName="payor_id"
			tabindex="-1"
			[fuzzySearchableClasses]="['payors']"
			(chosenEvent)="updField('payor_id')"
		/>
	}

	@if (row.patient_id && hasPayors) {
		<div class="colstat-price">
			<label>
				{{ "price_payor" | langVal }}
			</label>
			<app-gen-input
				[actualObj]="row"
				fieldName="price_payor"
				(changeEvent)="updField('price_payor')"
				isNumber
			/>
		</div>
	}

	@if (isManualChargeShown == "yes" && !store.hasInvoiceIdPerson(row)) {
		<app-gen-button-group
			[actualObj]="row"
			fieldName="charged_manualy"
			(changeEvent)="updField('charged_manualy')"
			optionsListName="charged_manualy_no_opts"
		/>

		@if (row.charged_manualy == "yes") {
			<app-gen-input
				title_ph_lang="external_invoice_id"
				[actualObj]="row"
				(changeEvent)="updField('external_invoice_id')"
				className="border-0"
				fieldName="external_invoice_id"
			/>
		}
	}
</div>
@switch (modalProps?.name) {
	@case ("autotext-menu") {
		<app-modal-wrap
			(onClose)="modalProps = null"
			title="autotexts"
			modalWrapperClass="modal-650"
		>
			<app-autotext-menu
				(onClose)="modalProps = null; injectDescription($event)"
			/>
		</app-modal-wrap>
	}
	@case ("tests-menu") {
		<app-modal-wrap
			(onClose)="modalProps = null"
			title="tests"
			modalWrapperClass="modal-small-width"
		>
			<app-tests-menu
				(onClose)="modalProps = null; injectDescription($event)"
				[patient_id]="row.patient_id"
			/>
		</app-modal-wrap>
	}
}
